import { Component } from '@angular/core';

import { Navbar } from '../../../layout/components/navbar/navbar.component';
import { Hero } from '../components/hero/hero.component';
import { TrustStrip } from '../components/trust-strip/trust-strip.component';
import { Stats } from '../components/stats/stats.component';
import { ServicesSection } from '../components/services-section/services-section.component';
import { GlobalNetwork } from '../components/global-network/global-network.component';
import { TestimonialsComponent } from '../components/testimonials/testimonials.component';
import { IndustriesComponent } from '../components/industries/industries.component';
import { FaqComponent } from '../components/faq/faq.component';
import { ProcessComponent } from '../components/process/process.component';
import { QuoteFormComponent } from '../components/quote-form/quote-form.component';
import { FooterComponent } from '../../../layout/components/footer/footer.component';

@Component({
  selector: 'app-home-page',
  imports: [
    Navbar,
    Hero,
    TrustStrip,
    Stats,
    ServicesSection,
    GlobalNetwork,
    TestimonialsComponent,
    IndustriesComponent,
    FaqComponent,
    ProcessComponent,
    QuoteFormComponent,
    FooterComponent,
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
})
export class HomePageComponent {}
